import styled from "styled-components";

export const EditionContainer = styled.div({
  flex: 1,
  minWidth: 500,
  paddingInline: 10,
  paddingBlock: 5,
  boxSizing: "border-box",
});
